import { render, staticRenderFns } from "./FooterCoventry.vue?vue&type=template&id=1581e954&"
import script from "./FooterCoventry.vue?vue&type=script&lang=js&"
export * from "./FooterCoventry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports